import { ReactNode, useCallback } from 'react';

import { OptionType } from 'components/Select/Select.types';
import { SelectInput } from 'components/SelectInput';
import { updateObject } from 'utils/functional';

import { Field } from './Field/Field';

type Props = {
  'aria-label'?: string;
  'data-qa-id'?: string;
  className?: string;
  customCompare?: (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    arg0: Record<string, any>,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    arg1: Record<string, any>,
  ) => boolean;
  disabled?: boolean;
  disableGreyOnNull?: boolean;
  name: string;
  value?: string;
  label?: ReactNode;
  description?: string;
  options: ReadonlyArray<
    OptionType & {
      disabled?: boolean;
    }
  >;
  onUpdateValue?: (value?: OptionType['value']) => void;
  noMargin?: boolean;
  noWrap?: boolean;
  hasError?: boolean;
  id?: string;
  onChange?: (arg0: string) => void;
  required?: boolean;
};

export function SelectField({
  name,
  label,
  description,
  options,
  noMargin,
  noWrap,
  onUpdateValue,
  required,
  ...props
}: Props) {
  const handleChange = useCallback(
    (updateValue: (v: unknown) => void) => (newValue: OptionType['value']) => {
      updateValue(newValue);

      if (onUpdateValue) {
        onUpdateValue(newValue);
      }
    },
    [onUpdateValue],
  );

  return (
    <Field
      inputProps={updateObject(props, {
        options,
      })}
      name={name}
      label={label}
      description={description}
      noMargin={noMargin}
      noWrap={noWrap}
      renderInput={({ value, id, qaId, hasError, updateValue }) => (
        <SelectInput
          id={id}
          name={name}
          value={value || ''}
          options={options}
          hasError={hasError}
          data-qa-id={qaId}
          onChange={handleChange(updateValue)}
          required={required}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      )}
    />
  );
}
